<template>
  <div>
    <el-alert
      title="从工单覆盖或安全库存差额生成采购建议草稿。确认后生成采购到货草稿。删除该到货草稿后，本建议会退回草稿，可再次确认重新生成。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.suggestionCode" clearable placeholder="建议编号" style="width:180px" @keyup.enter.native="search" />
      <el-select v-model="query.suggestionState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已确认" value="01" />
      </el-select>
      <el-select v-model="query.sourceType" clearable placeholder="来源" style="width:140px">
        <el-option label="工单覆盖" value="COVERAGE" />
        <el-option label="物料需求" value="REQUIREMENT" />
        <el-option label="最小库存" value="MIN_STOCK" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" plain @click="openGen">从覆盖生成</el-button>
      <el-button @click="doGenMinStock">从最小库存生成</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="suggestionCode" label="建议编号" width="200" />
      <el-table-column label="来源" width="110" align="center">
        <template slot-scope="{ row }">{{ sourceLabel(row.sourceType) }}</template>
      </el-table-column>
      <el-table-column prop="orderCode" label="工单号" width="160" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.suggestionState === '01' ? 'success' : 'info'">{{ row.suggestionState === '01' ? '已确认' : '草稿' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="arrivalCode" label="采购到货单" width="160" />
      <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
      <el-table-column prop="createDate" label="创建时间" width="170" />
      <el-table-column label="操作" width="240" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewRow(row.suggestionId)">查看</el-button>
          <el-button type="text" :disabled="row.suggestionState !== '00'" @click="confirmRow(row.suggestionId)">确认</el-button>
          <el-button type="text" :disabled="row.suggestionState !== '01'" @click="unconfirmRow(row.suggestionId)">反确认</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.suggestionState !== '00'" @click="onDelete(row.suggestionId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog title="从覆盖生成供应建议" :visible.sync="genVisible" width="480px" :close-on-click-modal="false">
      <el-select v-model="genOrderId" filterable clearable placeholder="选择工单" style="width:100%">
        <el-option v-for="item in orderOptions" :key="item.orderId" :label="(item.orderCode || '') + ' / ' + (item.orderName || '')" :value="item.orderId" />
      </el-select>
      <span slot="footer">
        <el-button @click="genVisible = false">取消</el-button>
        <el-button type="primary" :loading="genLoading" @click="doGen">生成</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'供应建议 ' + (detail.suggestionCode || '')" :visible.sync="detailVisible" width="860px">
      <p>工单：{{ detail.orderCode || '-' }}　状态：{{ detail.suggestionState === '01' ? '已确认' : '草稿' }}　到货单：{{ detail.arrivalCode || '-' }}</p>
      <el-table :data="detail.lines || []" border size="small">
        <el-table-column type="index" width="50" />
        <el-table-column prop="productNumber" label="物料编码" width="140" />
        <el-table-column prop="productName" label="物料名称" min-width="140" />
        <el-table-column prop="requiredQty" label="需求" width="100" align="right" />
        <el-table-column prop="stockQty" label="库存" width="90" align="right" />
        <el-table-column prop="reservedQty" label="占用" width="90" align="right" />
        <el-table-column prop="suggestQty" label="建议采购" width="110" align="right" />
      </el-table>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listSupplySuggestion, getSupplySuggestion, generateSupplySuggestion,
  generateSupplySuggestionFromMinStock, confirmSupplySuggestion, unconfirmSupplySuggestion, deleteSupplySuggestion
} from '../../api/supplySuggestion'
import { selectProductionOrder } from '../../api/productionOrder'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { suggestionCode: '', suggestionState: '', sourceType: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      genVisible: false, genOrderId: '', orderOptions: [], genLoading: false,
      detailVisible: false, detail: {}
    }
  },
  created() { this.load() },
  methods: {
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    sourceLabel(s) {
      return { COVERAGE: '工单覆盖', REQUIREMENT: '物料需求', MIN_STOCK: '最小库存' }[s] || s
    },
    load() {
      this.loading = true
      listSupplySuggestion({
        currentPage: this.page, pageSize: this.pageSize,
        suggestionCode: this.query.suggestionCode,
        suggestionState: this.query.suggestionState,
        sourceType: this.query.sourceType
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openGen() {
      this.genOrderId = ''
      this.genVisible = true
      selectProductionOrder().then(res => { this.orderOptions = res.data || [] }).catch(() => {})
    },
    doGen() {
      if (!this.genOrderId) {
        this.$message.warning('请选择工单')
        return
      }
      this.genLoading = true
      generateSupplySuggestion({ orderId: this.genOrderId }).then(() => {
        this.$message.success('生成成功')
        this.genVisible = false
        this.search()
      }).finally(() => { this.genLoading = false })
    },
    doGenMinStock() {
      this.$confirm('将按安全库存差额生成供应建议草稿？', '提示', { type: 'warning' }).then(() => {
        generateSupplySuggestionFromMinStock().then(() => {
          this.$message.success('生成成功')
          this.search()
        })
      }).catch(() => {})
    },
    viewRow(id) {
      getSupplySuggestion(id).then(res => {
        this.detail = res.data || {}
        this.detailVisible = true
      })
    },
    confirmRow(id) {
      this.$confirm('确认该供应建议？将自动生成采购到货草稿', '提示', { type: 'warning' }).then(() => {
        confirmSupplySuggestion(id).then(res => {
          const code = res.data && res.data.arrivalCode
          this.$message.success(code ? ('已确认，采购到货单 ' + code) : '已确认')
          this.load()
        })
      }).catch(() => {})
    },
    unconfirmRow(id) {
      this.$confirm('反确认后将退回草稿，并删除尚未入库确认的采购到货单。之后可删除本建议。', '提示', { type: 'warning' }).then(() => {
        unconfirmSupplySuggestion(id).then(() => {
          this.$message.success('已反确认')
          this.load()
        })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteSupplySuggestion([id]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
